<!--一体化教研菜单-->
<template>
    <div class="menu-container">
        <div @click="changeItem('2')" :class="activeItem==='2'?'menu-item menu-active':'menu-item'">个人备课</div>
        <div @click="changeItem('3')" :class="activeItem==='3'?'menu-item menu-active':'menu-item'">协同备课</div>
        <div @click="changeItem('5')" :class="activeItem==='5'?'menu-item menu-active':'menu-item'">听课评课</div>
        <div @click="changeItem('4')" :class="activeItem==='4'?'menu-item menu-active':'menu-item'">已发布备课</div>
    </div>
</template>

<script>

export default {
    name:'eduResearchMenu',
    components:{},
    props:{
        itemNum:{
            type: String,
            default:"2"
        },
        studioNature:{
            type: String,
            default:"2"
        },
    },
    watch:{
        itemNum(newValue,oldValue){
            this.activeItem = newValue;
        },
    },
    mounted() {},
    data() {
        return {
            activeItem:this.itemNum,
        }
    },
    methods: {
        changeItem(item){
            this.activeItem = item;
            this.$emit('change-item', item );
        },
    }
}

</script>

<style scoped>
.menu-container{
    display: inline-flex;
    align-items: center;
    gap: 16px;
    flex-shrink: 0;
}
.menu-item{
    height: 38px;
    line-height: 38px;
    padding: 0 22px;
    box-sizing: border-box;
    text-align: center;
    font-size: 16px;
    color: #ff7f2e;
    background: #fff;
    border: 1px solid #ff7f2e;
    border-radius: 19px;
    cursor: pointer;
    white-space: nowrap;
}
.menu-active{
    background: #ff7f2e;
    border-color: #ff7f2e;
    color: #fff;
}
</style>
